import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import BottomNav from "./BottomNav";

export default function AppLayout({ children, breadcrumbs }) {
  return (
    <div className="min-h-screen flex bg-[hsl(var(--bg-base))]">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <Header breadcrumbs={breadcrumbs} />
        <main className="flex-1 px-4 md:px-8 py-6 md:py-8 pb-24 md:pb-8" data-testid="app-main">
          {children}
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
